import { useEffect, useRef } from "react";
import { useShallow } from "zustand/shallow";
import { useGlobalStore } from "../stores/globalStore";
import { useCheckoutStore } from "../stores/checkoutStore";
import { useProductOffer } from "./useFetchProductOffer";
import { useCreateCart } from "./useCreateCart";
import { useValidateShoppingCart } from "./useValidateShoppingCart";
import { useGetStructure } from "./useGetStructure";

export const useAppInitializer = () => {

  const { productKey, setShoppingCart, setQraphqlResponse } = useGlobalStore(useShallow((state) => ({
    setQraphqlResponse: state.setQraphqlResponse,
    setShoppingCart: state.setShoppingCart,
    productKey: state.productKey,
  })));
  const { data } = useProductOffer(productKey);
  const createShoppingCart = useCreateCart();
  const validateShoppingCart = useValidateShoppingCart();
  const { fetchStructure } = useGetStructure();

  const setStructure = useCheckoutStore((state) => state.setStructure);

  const initialized = useRef(false);

  useEffect(() => {
    if (!data || initialized.current) return;
    initialized.current = true;
    const init = async () => {
      try {
        setQraphqlResponse(data?.data);

        const cart = await createShoppingCart({
          ProductOffer: data?.data?.data?.getProductOfferByID?.[0],
          productId: productKey,
          specialApps: [],
        });
        const validatedCart = await validateShoppingCart(cart.data.id);
        setShoppingCart(validatedCart.data?.shoppingCart);

        const structure = await fetchStructure(validatedCart.data?.shoppingCart);
        setStructure(structure.data);
      } catch {
        // Error display handled by queryClient MutationCache.onError
      }
    };

    init();
  }, [data]);
};